<div class="pr-4">
  <app-main-table [tableConfig]="tableConfig" class="loop-operator-filter-result"></app-main-table>
</div>
